import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../../lib/constants';

export const useAccessCheck = () => {
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const source = axios.CancelToken.source();

    const checkAccess = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/access_add_user`, {
          withCredentials: true,
          cancelToken: source.token,
        });

        if (response.status === 200 && response.data.status === 'success') {
          setHasAccess(true);
        } else {
          setHasAccess(false);
        }
      } catch (err) {
        if (!axios.isCancel(err)) {
          setError(err.response?.data?.message || err.message || 'Access check failed');
          setHasAccess(false);
        }
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
    return () => source.cancel('Component unmounted');
  }, []);

  // Redirect if access granted
  useEffect(() => {
    if (!loading && hasAccess) {
      navigate('/addUser');
    }
  }, [loading, hasAccess, navigate]);

  // Handle countdown and redirect if no access
  useEffect(() => {
    if (!loading && !hasAccess) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            navigate('/');
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [loading, hasAccess, navigate]);

  return { loading, hasAccess, error, countdown };
};
